export default "/images/layout-3.jpg?ab7913ef54c4b35854bc8a9488e127c0";